import { IOrganizationSchoolBoard } from '../model/IOrganizationSchoolBoard'
import axiosInstance from '../services/apis'

export const getSchoolBoards = async (prov: string) => {
    const response: IOrganizationSchoolBoard[] = await axiosInstance.get(
        `/api/organization/school-boards/${prov}`
    )
    return response
}

export const getOrgLocationByOrgGuid = async (
    orgGuid: string,
    prov: string
) => {
    const response: IOrganizationSchoolBoard = await axiosInstance.get(
        `/api/organization/org-guid/${orgGuid}/${prov}`
    )
    return response
}
